import React from 'react';

const CmsSeparator = () => <hr />;
CmsSeparator.noMargin = true;
export default CmsSeparator;
